export const BASE_URL = '/dashboard'
export const BASE_TITLE = ' | Risiko Idea'
export const CONFIG = {
  layout: 'vertical',
  preLayout: 'layout-2',
  configBlock: true,
  isOpen: [],
  isTrigger: [],
  collapseMenu: false,
  headerFixedLayout: true,
}
// eslint-disable-next-line
export default { CONFIG, BASE_URL, BASE_TITLE }
